import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircularProgress from "@mui/material/CircularProgress";
import InfoIcon from "@mui/icons-material/Info";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { useFormState } from "react-hook-form";

const style = {
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
};

const FormState = ({ control }) => {
  const {
    isSubmitting,
    isDirty,
    errors,
    isSubmitted,
    isSubmitSuccessful,
    isLoading,
    isValid,
    isValidating,
    dirtyFields,
  } = useFormState({ control });

  if (isLoading)
    return (
      <Typography variant="caption" sx={style}>
        <CircularProgress size="0.9em" style={{ padding: "5px" }} />
        Loading
      </Typography>
    );

  if (isSubmitting)
    return (
      <Typography variant="caption" sx={style}>
        <CircularProgress size="0.9em" style={{ padding: "5px" }} />
        Submitting
      </Typography>
    );

  if (isValidating)
    return (
      <Typography variant="caption" sx={style}>
        <CircularProgress size="0.9em" style={{ padding: "5px" }} />
        Validating
      </Typography>
    );

  if (!isValid && JSON.stringify(errors) !== "{}")
    return (
      <Typography variant="caption" sx={{ ...style, color: "warning.main" }}>
        <Tooltip
          title={<pre>{JSON.stringify(errors, null, 4)}</pre>}
          placement="top"
        >
          <InfoIcon sx={{ scale: "0.6" }} />
        </Tooltip>
        Errors
      </Typography>
    );

  if (isDirty) {
    return (
      <Typography variant="caption" sx={{ ...style, color: "warning.main" }}>
        <Tooltip
          title={<pre>{JSON.stringify(dirtyFields, null, 4)}</pre>}
          placement="top"
        >
          <InfoIcon sx={{ scale: "0.6" }} />
        </Tooltip>
        Not saved
      </Typography>
    );
  }

  if (isSubmitted && !isSubmitSuccessful)
    return (
      <Typography variant="caption" sx={{ ...style, color: "error.main" }}>
        <WarningAmberIcon sx={{ scale: "0.6" }} />
        Can't save
      </Typography>
    );

  if (isSubmitSuccessful)
    return (
      <Typography variant="caption" sx={{ ...style, color: "success.main" }}>
        <CheckCircleIcon sx={{ scale: "0.6" }} />
        Saved
      </Typography>
    );
};

export default FormState;
